export default __webpack_public_path__ + "static/media/home-finance-hero-img.7014606b.jpg";